import { IWithChildren } from 'types';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const BoxWithShadow = (
  { children, className, noMobileGradient }: IWithChildren & { className?: string, noMobileGradient?: boolean },
) => <article className={classNames(styles.box, noMobileGradient ? styles.noGradient : '', className)}>{children}</article>;
